export function AuthorOrganizations({ organizations }) {
  if (!organizations || organizations.length === 0) return null;
  return (
    <div className="border-b border-gray-300 p-2 flex flex-row gap-2 my-2 md:w-3/4 w-full mx-auto justify-center">
      <h3 className="text-sm font-medium">Organizaciones:</h3>
      <h3 className="text-sm font-normal italic">
        {organizations.join(" - ")}
      </h3>
    </div>
  );
}
